module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.challenge._id) ? _c('div', {
    staticClass: "collect bg"
  }, [_c('div', {
    staticClass: "list"
  }, [(_vm.challenge && _vm.challenge.productInfo) ? _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "src": _vm.UPLOAD_DOMAIN + _vm.challenge.productInfo.thumbnail + '?x-oss-process=image/resize,w_100',
      "default-src": "static/placeholder.png",
      "container": "#vux_view_box_body"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "wz"
  }, [_c('div', {}, [_vm._v("\n                    " + _vm._s(_vm.challenge.productInfo.title) + "\n                ")])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "list"
  }, [_c('div', [_vm._v("\n            这是" + _vm._s(_vm.challenge.nickname) + "想要的0元好礼，赶快下方扫描二维码，关注生活道，帮他达成心愿吧。\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "white-box qrcode"
  }, [_c('img', {
    attrs: {
      "src": _vm.challenge.qrcodeImgUrl,
      "default-src": "static/placeholder.png",
      "container": "#vux_view_box_body"
    }
  }), _vm._v(" "), _c('div', [_vm._v("长按识别二维码，关注生活道")])])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2ee43176"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UserCenter/invite/inviteChallenge.vue
// module id = 539
// module chunks = 0